export interface MockApp {
  id: string;
  name: string;
  description: string;
  icon: string;
  url: string;
  category: 'core' | 'utility' | 'external';
  status: 'active' | 'maintenance' | 'inactive';
}

export const mockApps: MockApp[] = [
  {
    id: 'mock-app',
    name: 'Mock Application',
    description: 'A demonstration embedded application',
    icon: '📦',
    url: '/mock-app.html',
    category: 'core',
    status: 'active',
  },
  {
    id: 'mock-dashboard',
    name: 'Analytics Dashboard',
    description: 'Visual analytics and reporting tool',
    icon: '📊',
    url: '/mock-dashboard.html',
    category: 'utility',
    status: 'active',
  },
  {
    id: 'external-docs',
    name: 'Documentation',
    description: 'External documentation portal',
    icon: '📚',
    url: 'https://example.com/docs',
    category: 'external',
    status: 'active',
  },
];
